/* Stories de resultado — player autônomo, para a PDP padrão.

   É o mesmo comportamento que vive dentro de lp-hit.js (bloco `stories()`),
   extraído para rodar sozinho em páginas que não carregam a LP inteira.

   DÍVIDA CONHECIDA: o mesmo player existe em dois lugares, e eles PODEM cair
   na mesma página — a PDP padrão carrega o lp-hit.js junto com a dobra "A
   rotina". Por isso a guarda logo abaixo. Para unificar de vez, remover o
   bloco `stories()` de lp-hit.js e fazer hit-hero carregar este arquivo; aí a
   guarda sai junto. */
(function () {
  'use strict';

  /* Cede a vez para o lp-hit.js. A PDP padrão carrega ele quando a dobra "A
     rotina" aparece, e lá dentro existe o mesmo player: sem esta guarda os
     dois se registram no mesmo botão e o story avança de dois em dois no fim
     do vídeo. Como ambos os scripts são defer, quando este roda a árvore já
     está completa e a tag do outro, se existir, está no DOM. */
  if (document.querySelector('script[src*="lp-hit.js"]')) return;

  var raiz = document.querySelector('.nvsv');
  if (!raiz) return;

  var bolhas = Array.prototype.slice.call(raiz.querySelectorAll('.nvsv__bubble'));
  var modal = raiz.querySelector('.nvsvm');
  if (!bolhas.length || !modal) return;

  var video = modal.querySelector('.nvsvm__video');
  var legenda = modal.querySelector('.nvsvm__caption');
  var progresso = modal.querySelector('.nvsvm__progress span');
  var atual = -1;

  function fonte(i) {
    var v = bolhas[i].querySelector('.nvsv__hidden source');
    return v ? v.getAttribute('src') : '';
  }

  function tocar(i) {
    if (i < 0 || i >= bolhas.length) { fechar(); return; }
    atual = i;
    var src = fonte(i);
    if (!src) { tocar(i + 1); return; }

    bolhas[i].classList.add('is-visto');
    legenda.textContent = bolhas[i].getAttribute('data-caption') ||
                          (bolhas[i].querySelector('.nvsv__name') || {}).textContent || '';
    progresso.style.width = '0%';
    video.src = src;
    video.currentTime = 0;
    video.play().catch(function () {});
  }

  function abrir(i) {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    tocar(i);
  }

  function fechar() {
    modal.hidden = true;
    document.body.style.overflow = '';
    video.pause();
    video.removeAttribute('src');
    video.load();
    atual = -1;
  }

  bolhas.forEach(function (b, i) {
    b.addEventListener('click', function () { abrir(i); });
  });

  video.addEventListener('timeupdate', function () {
    if (!video.duration) return;
    progresso.style.width = (video.currentTime / video.duration * 100) + '%';
  });
  video.addEventListener('ended', function () { tocar(atual + 1); });

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]')) { fechar(); return; }
    if (e.target.closest('[data-next]')) { tocar(atual + 1); return; }
    if (e.target.closest('[data-prev]')) { tocar(atual - 1); }
  });

  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') fechar();
    if (e.key === 'ArrowRight') tocar(atual + 1);
    if (e.key === 'ArrowLeft') tocar(atual - 1);
  });
})();